import styled, { css } from 'styled-components';
import {
  brand,
  breakpoints,
  ink,
  surface,
  tones,
  touchTarget,
} from '../../../styles/brand';

export const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  margin-top: 1.2rem;
  padding: 1.25rem 1.5rem;
  border-radius: 1rem;
  border: 1px solid ${surface.line};
  background: ${brand.white};

  @media (max-width: ${breakpoints.md}) {
    flex-wrap: wrap;
    gap: 0.9rem;
    padding: 1rem;
  }
`;

/** Selo de arquivo: mostra o formato antes do nome. */
export const FileBadge = styled.span`
  flex: none;
  width: 3.25rem;
  height: 3.75rem;
  display: grid;
  place-items: end center;
  padding-bottom: 0.55rem;
  border-radius: 0.5rem 1rem 0.5rem 0.5rem;
  background: ${tones.orange.soft};
  border: 1.5px solid ${tones.orange.border};
  font-family: 'RedHatDisplay-ExtraBold';
  font-size: 0.75rem;
  letter-spacing: 0.06em;
  color: ${tones.orange.text};
`;

export const Info = styled.div`
  flex: 1;
  min-width: 12rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  h3 {
    margin: 0;
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.1rem;
    letter-spacing: -0.01em;
    color: ${ink};
  }

  p {
    margin: 0;
    max-width: 38rem;
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.9rem;
    line-height: 1.45;
    color: ${tones.gray.text};
  }
`;

const buttonBase = css`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: ${touchTarget};
  padding: 0 1.25rem;
  border-radius: 0.65rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.95rem;
  white-space: nowrap;

  svg {
    width: 1.2rem;
    height: 1.2rem;
  }

  @media (max-width: ${breakpoints.md}) {
    width: 100%;
  }
`;

export const DownloadButton = styled.a`
  ${buttonBase}
  background: ${brand.orange};
  color: ${brand.white};
  box-shadow: 0 3px 6px rgba(255, 152, 0, 0.3);
  text-decoration: none;
  touch-action: manipulation;
  transition: transform 100ms ease-out;

  &:active {
    transform: scale(0.97);
  }

  &:focus-visible {
    outline: 2px solid ${brand.blue};
    outline-offset: 2px;
  }
`;

export const PendingButton = styled.button`
  ${buttonBase}
  border: 1.5px dashed ${brand.gray};
  background: transparent;
  color: ${tones.gray.text};
  cursor: not-allowed;
`;
